import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import NotFound from './pages/NotFound.tsx';
import Home from './pages/Home';
import FAQPage from './pages/FAQ';
import AboutContact from './pages/AboutContact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const languages = ['en', 'fr', 'de'];

const router = createBrowserRouter([
  // Root path (English)
  {
    path: '/',
    element: <App defaultLanguage="en" />,
    children: [
      { path: '/', element: <Home /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'about', element: <AboutContact /> },
      { path: 'privacy', element: <PrivacyPolicy /> },
      { path: 'terms', element: <TermsOfService /> },
    ]
  },
  // Other languages
  ...languages.filter(lang => lang !== 'en').map(lang => ({
    path: `/${lang}`,
    element: <App defaultLanguage={lang} />,
    children: [
      { path: '', element: <Home /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'about', element: <AboutContact /> },
      { path: 'privacy', element: <PrivacyPolicy /> },
      { path: 'terms', element: <TermsOfService /> },
    ]
  })),
  // 404 route
  {
    path: '*',
    element: <NotFound />
  }
]);

export default router; 